<template lang="pug">
v-content
  v-dialog(v-model="dialog" width="70vw")
    v-responsive(:aspect-ratio="16/9" v-if="tour" :key="tour")
      iframe(width="100%" height="100%" :src="tour.url" frameborder="0" allow="encrypted-media;" allowfullscreen)
  
  v-container
    v-row(justify="center")
      v-col(cols=12 lg=10 xl=8)
        v-row(justify="center")
          v-col(cols=12 sm=6 lg=4 v-for="t in tours" :key="t.id")
            v-hover(v-slot:default="{ hover }")
              v-card(hover @click="tour=t; dialog=true")
                v-img(:src="require(`@/assets/tour/${t.id}.jpg`)" :class="{ 'show-overlay': hover }")
                  v-overlay(:value="hover" absolute).text-center
                    h1.headline {{ t.name }}
                    h1.subtitle-1 {{ t.loc }}
</template>

<script>
export default {
  name: 'Tour',
  data() {
    return {
      dialog: false,
      tour: null,
      tours: [
        {
          id: 1,
          name: 'Александровский дворец',
          loc: 'Пушкин, Россия',
          url: '//www.panoramas.classic-ru.org/alex/al1.htm',
        },
        {
          id: 2,
          name: 'Колизей',
          loc: 'Рим Италия',
          url: '//www.airpano.ru/files/Italy-Rome-Colosseum/1-3-2',
        },
        {
          id: 3,
          name: 'Великие Египетские пирамиды',
          loc: 'Гиза, Египет',
          url: '//www.airpano.ru/files/Egypt-Cairo-Pyramids/1-3-2',
        },
        {
          id: 4,
          name: 'Эйфелева башня',
          loc: 'Париж, Франция',
          url: '//www.airpano.ru/files/Eiffel-Tower-Paris-France/1-3-2',
        },
        {
          id: 5,
          name: 'Пизанская башня',
          loc: 'Пиза, Италия',
          url: '//www.airpano.ru/files/Pisa-Tuscany-Central-Italy/1-3-2',
        },
        {
          id: 6,
          name: 'Лувр',
          loc: 'Париж, Франция',
          url: '//www.youvisit.com/tour/louvremuseum',
        },
        {
          id: 7,
          name: 'Ватикан',
          loc: 'Рим, Италия',
          url: '//www.airpano.ru/files/Vatican/1-3-2',
        },
        {
          id: 8,
          name: 'Дворцовая площадь',
          loc: 'Санкт-Петербург, Россия',
          url: '//www.panoramas.classic-ru.org/spb/tour_010.htm',
        },
        {
          id: 9,
          name: 'Петергоф',
          loc: 'Санкт-Петербург, Россия',
          url: '//www.airpano.ru/files/Peterhof-Sankt-Petersburg-Russia/1-3-2',
        },
        {
          id: 10,
          name: 'Тадж-Махал',
          loc: 'Агра, Индия',
          url: '//www.airpano.ru/files/Taj-Mahal-India/1-3-2',
        },
        {
          id: 11,
          name: 'Большой Театр',
          loc: 'Москва, Россия',
          url:
            '//www.google.com/maps/embed?pb=!4v1586314195026!6m8!1m7!1sExmkYgVoIxiNlema_l1UsQ!2m2!1d55.76000461901661!2d37.61871298493284!3f335.59!4f-11.370000000000005!5f0.5970117501821992',
        },
        {
          id: 12,
          name: 'Родина-мать',
          loc: 'Волгоград, Россия',
          url: '//sphaira.ru/virtualtours/muzeum/mamaevkurgan.html',
        },
      ],
    }
  },
  components: {},
  computed: {},
}
</script>